var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",attrs:{"id":"app"}},[_c('nav-bar'),_c('main',{attrs:{"id":"main"}},[_c('router-view')],1),_c('Footer'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"back-to-top",attrs:{"href":"#"}},[_c('i',{staticClass:"icofont-simple-up"})])
}]

export { render, staticRenderFns }